<template>
    <section class="hero is-fullheight">
        <div class="hero-head">
            <commemoria-navbar></commemoria-navbar>
            <div class="container is-fluid">

                <header class="media">
                    <div class="media-left">
                        <b-tooltip label="Modifier la vignette" type="is-dark" position="is-bottom">
                            <div class="box" style="margin: 0; padding: 0;">
                                <figure class="image" style="margin: 0 auto; width: 96px; height: 96px;" @click="avatarModal()">
                                    <img :src="timeline.avatar.url" v-if="timeline.avatar" />
                                    <svg height="100%" version="1.1" viewBox="0 0 16 16" width="100%" xmlns="http://www.w3.org/2000/svg" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" xmlns:xlink="http://www.w3.org/1999/xlink" v-if="!timeline.avatar" style="padding: 15px;">
                                        <title/>
                                        <defs/>
                                        <g fill="none" fill-rule="evenodd" id="Icons with numbers" stroke="none" stroke-width="1">
                                            <g fill="#363636" id="Group" transform="translate(-528.000000, -192.000000)">
                                                <path d="M528,194 L544,194 L544,206 L528,206 Z M529,195 L529,205 L543,205 L543,195 Z M530.006104,204.026611 C530.006104,204.026611 531.046143,197.003662 532.590332,197.003662 C534.134521,197.003662 534.810913,201.95752 536.053223,201.95752 C537.295532,201.95752 537.201904,200.021851 538.111328,200.021851 C539.020752,200.021851 542.151123,204.026611 542.151123,204.026611 Z M540.5,199 C539.671573,199 539,198.328427 539,197.5 C539,196.671573 539.671573,196 540.5,196 C541.328427,196 542,196.671573 542,197.5 C542,198.328427 541.328427,199 540.5,199 Z M540.5,199" id="Oval 236"/>
                                            </g>
                                        </g>
                                    </svg>
                                </figure>
                            </div>
                        </b-tooltip>
                    </div>
                    <div class="media-content">
                        <div class="content">
                            <div class="level" style="margin-top: 10px; margin-bottom: 20px;">
                                <!-- Left side -->
                                <div class="level-left">
                                    <div class="level-item">
                                        <p class="title" style="font-size: 1.5rem;">
                                            {{ timeline.title }}
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="level">
                                <!-- Left side -->
                                <div class="level-left">
                                    <div class="level-item"> 
                                        <p class="is-italic" style="font-size: 1rem; opacity: 0.7;">
                                            <i class="fa fa-user" aria-hidden="true" style="padding-right: 0.5rem;"></i>
                                            <span>{{ timeline.author.name }}</span>
                                        </p>                               
                                    </div>
                                </div>
                                <!-- Right side -->
                                <div class="level-right" v-if="!timeline.locked">
                                    <div class="level-item">
                                        <div class="buttons">
                                            <b-tooltip label="Contextualiser" type="is-dark" position="is-bottom">
                                                <button class="button is-light" @click="addTimelineToContextualizationTimelines()">
                                                    <span class="icon is-small">
                                                        <i class="fa fa-cubes fa-lg" aria-hidden="true"></i>
                                                    </span>
                                                </button>
                                            </b-tooltip>
                                    
                                            <b-tooltip label="Présentation" type="is-dark" position="is-bottom">
                                                <router-link :to="{name: 'timelines.present', params: {id: timeline.id }}" class="button is-light" exact>
                                                    <span class="icon is-small">
                                                        <i class="fa fa-television" aria-hidden="true"></i>
                                                    </span>
                                                </router-link>
                                            </b-tooltip>
                                        
                                            <template v-if="policies.timeline.publish || timeline.published">
                                                <b-tooltip :label="timeline.published ? 'Lien public' : 'Publier'" type="is-dark" position="is-bottom">
                                                    <button class="button is-light" @click="publishModal()">
                                                        <span class="icon is-small">
                                                            <i class="fa fa-globe fa-lg" aria-hidden="true"></i>
                                                        </span>
                                                    </button>
                                                </b-tooltip>
                                            </template>
                                            
                                            <template v-if="policies.timeline.share">
                                                <b-tooltip label="Partager" type="is-dark" position="is-bottom">
                                                    <button class="button is-light" @click="shareModal()">
                                                        <span class="icon is-small">
                                                            <i class="fa fa-users fa-lg" aria-hidden="true"></i>
                                                        </span>
                                                    </button>
                                                </b-tooltip>
                                            </template>
                                        
                                            <template v-if="!policies.timeline.share">
                                                <b-tooltip label="Supprimer mon accès" type="is-dark" position="is-bottom">
                                                    <button class="button is-light" @click="confirmLeave()">
                                                        <span class="icon is-small">
                                                            <i class="fa fa-chain-broken fa-lg" aria-hidden="true"></i>
                                                        </span>
                                                    </button>
                                                </b-tooltip>
                                            </template>

                                            <template v-if="policies.timeline.export">
                                                <b-tooltip label="Exporter" type="is-dark" position="is-bottom">
                                                    <button class="button is-light" @click="exportModal()">
                                                        <span class="icon is-small">
                                                            <i class="fa fa-share-square-o fa-lg" aria-hidden="true"></i>
                                                        </span>
                                                    </button>
                                                </b-tooltip>
                                            </template>
                                    
                                            <template v-if="policies.timeline.duplicate">
                                                <b-tooltip label="Dupliquer" type="is-dark" position="is-bottom">
                                                    <button class="button is-light" @click="duplicate()">
                                                        <span class="icon is-small">
                                                            <i class="fa fa-clone fa-lg" aria-hidden="true"></i>
                                                        </span>
                                                    </button>
                                                </b-tooltip>
                                            </template>

                                            <template v-if="policies.timeline.delete">
                                                <b-tooltip label="Supprimer" type="is-dark" position="is-bottom">
                                                    <button class="button is-light" @click="confirmDestroy">
                                                        <span class="icon is-small">
                                                            <i class="fa fa-trash-o fa-lg" aria-hidden="true"></i>
                                                        </span>
                                                    </button>
                                                </b-tooltip>
                                            </template>

                                            <template v-if="policies.timeline.update">
                                                <b-tooltip label="Modifier" type="is-dark" position="is-bottom">
                                                    <button class="button is-light" @click="editModal()">
                                                        <span class="icon is-small">
                                                            <i class="fa fa-pencil fa-lg" aria-hidden="true"></i>
                                                        </span>
                                                    </button>
                                                </b-tooltip>
                                            </template>
                                        </div>
                                    </div>
                                    <div class="level-item" v-if="policies.events.create">
                                        <button class="button is-primary" @click="createEventModal()">Créer un événement</button>
                                    </div>
                                </div>
                            </div>
                        </div>    
                    </div>
                </header>
                <div class="meta" style="padding: 0.75rem 0px;" v-if="!loading">
                    <p class="subtitle" style="font-size: 1rem;">
                        {{ timeline.description }}
                    </p>
                </div>
            </div>
        </div>
        <div class="hero-body" style="padding-top: 0.75em;">
            <div class="container is-fluid">
                <div v-if="!loading">
                    <div class="has-text-centered" v-if="timeline.locked">
                        <div v-if="timeline.owner.id == user.id">
                            <h2 class="title" style="font-size: 1.25rem;">Votre abonnement a expiré.</h2>
                            <p>
                                Néanmoins, les données de cette ligne du temps sont conservées pendant 1 mois après l'expiration de votre abonnement. <br />
                                Vous aurez à nouveau un accès complet à cette ligne du temps dès que le renouvellement de votre abonnement aura été effectué.
                            </p>
                        </div>
                        <div v-else>
                            <h2 class="title" style="font-size: 1.25rem;">L'abonnement du propriétaire de cette ligne du temps a expiré.</h2>
                            <p>
                                Néanmoins, les données de cette ligne du temps sont conservées pendant 1 mois après l'expiration de l'abonnement. <br />
                                Cette ligne du temps sera à nouveau accessible dès que le renouvellement de l'abonnement aura été effectué.
                            </p>
                        </div>
                    </div>
                    <div v-else>
                        <div class="box" v-if="events.length > 0">
                            <ul class="timeline">
                                <template v-for="(item, index) in groupedEvents">
                                    <template v-if="item.length > 1">
                                        <sortable-list v-model="groupedEvents[index]" :x-axis="false" :constrainToContainer="true" @sorted="reorder">
                                            <div slot-scope="{ items }">
                                                <sortable-item v-for="event in items" :key="event.id">
                                                    <event :data="event" :contextualization="false" :sortable="true"></event>
                                                </sortable-item>
                                            </div>
                                        </sortable-list>
                                    </template>
                                    <template v-else>
                                        <event :data="item[0]" :contextualization="false" :sortable="false"></event>
                                    </template>
                                </template>
                            </ul>
                        </div>
                        <p class="has-text-centered" v-if="events.length == 0">
                            Il n'y aucun événement sur cette ligne du temps
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="hero-foot">
            <commemoria-footer></commemoria-footer>
        </div>
        <b-loading :active.sync="loading"></b-loading>
        <template v-if="!loading">
            <div style="height:144px;" v-if="contextualizationPanel.visible && contextualizationPanel.extended"></div>
            <contextualization-panel></contextualization-panel>
        </template>
    </section>
</template>

<script>
    import eventComponent from './_event';
    
    export default {
        components: {
            'event': eventComponent
        },

        data() {
            return {
                loading: true,
                timeline: {
                    id: 0,
                    owner: {
                        name: ''
                    },
                    author: {
                        name: ''
                    }
                },
                events: [],
                policies: {
                    timeline: {},
                    events: {}
                },
            }
        },

        computed: {
            user() {
                return this.$store.state.account;
            },

            contextualizationTimelines() {
                return this.$store.getters.contextualizationTimelines;
            },

            contextualizationPanel() {
                return this.$store.getters.contextualizationPanel;
            },

            groupedEvents() {
                return _.groupBy(this.events, 'start');
            },
        },

        watch: {
            '$route' (to, from) {
                this.fetchData(to.params.id);
            }
        },

        methods: {
            confirmDestroy() {
                this.$buefy.dialog.confirm({
                    title: 'Supprimer la ligne du temps',
                    message: 'Êtes-vous certain de vouloir <b>supprimer</b> cette ligne du temps ? <br />Cette action ne peut pas être annulée.',
                    confirmText: 'Supprimer la ligne du temps',
                    cancelText: 'Annuler',
                    type: 'is-danger',
                    hasIcon: false,
                    onConfirm: () => this.destroy()
                })
            },

            confirmLeave() {
                this.$buefy.dialog.confirm({
                    title: 'Supprimer mon accès',
                    message: 'Êtes-vous certain de vouloir <b>supprimer votre accès</b> à cette ligne du temps partagée ? Celle-ci n\'apparaitra plus dans votre compte et vous ne pourrez plus y accéder.',
                    confirmText: 'Supprimer mon accès',
                    cancelText: 'Annuler',
                    type: 'is-danger',
                    hasIcon: false,
                    onConfirm: () => this.leave()
                })
            },

            addTimelineToContextualizationTimelines() {
                if (! _.find(this.contextualizationTimelines, ['id', this.timeline.id])) {
                    if ( this.contextualizationTimelines.length < 4) {
                        this.$store.dispatch('addTimelineToContextualization', this.timeline);    
                    } else {
                        this.$buefy.toast.open({
                            message: 'Malheureusement, vous ne pouvez contextualiser que 4 lignes du temps. Veuillez en supprimer une.',
                            type: 'is-danger'
                        });
                    }
                }
            },

            destroy() {
                axios.delete('/api/v1/timelines/'+this.$route.params.id)
                .then( response => {
                    this.$router.push({ name: 'timelines.index'});

                    this.$buefy.toast.open({
                        message: 'La ligne du temps a été supprimée',
                        type: 'is-success'
                    });
                }).catch(response => {
                    this.$buefy.toast.open({
                        message: 'Une erreur s\'est produite',
                        type: 'is-danger'
                    });
                });
            },

            leave() {
                axios.delete('/api/v1/memberships', { data: {
                    user_id: this.user.id,
                    timeline_id: this.timeline.id
                }}).then(response => {
                
                    this.$buefy.toast.open({
                        message: 'La ligne du temps partagée a été supprimée de votre compte',
                        type: 'is-success'
                    });

                    this.$router.push({ name: 'timelines.index' });

                    Bus.$emit('timelines.fetch');                

                }).catch(response => {
                    this.$buefy.toast.open({
                        message: 'Une erreur s\'est produite',
                        type: 'is-danger'
                    });
                });    
            },

            duplicate() {
                this.loading = true;

                axios.post('/api/v1/timelines/' + this.timeline.id + '/duplicate')
                .then(response => {
                    this.$buefy.toast.open({
                        message: 'La ligne du temps a été dupliquée',
                        type: 'is-success'
                    });

                    this.loading = false;

                }).catch(error => {
                    this.$buefy.toast.open({
                        message: 'Une erreur s\'est produite',
                        type: 'is-danger'
                    });

                    this.loading = false;
                });
            },

            reorder(events) {
                var data = _.map(events, 'id');

                axios.post('/api/v1/timelines/' + this.$route.params.id + '/events/reorder', data)
                     .then(response => {
                        this.$buefy.toast.open({
                            message: 'L\'ordre des événements a été modifié',
                            type: 'is-success'
                        });
                    }); 
            },
            
            editModal() {   
                this.$buefy.modal.open({
                    parent: this,
                    component: require('../../modals/editTimeline').default,
                    props: {
                        timeline: this.timeline,
                    },
                    hasModalCard: true
                });
            },

            avatarModal() {  
                this.$buefy.modal.open({
                    parent: this,
                    component: require('../../modals/timelineAvatar').default,
                    props: {
                        timeline: this.timeline,
                    },
                    hasModalCard: true
                });
            }, 

            shareModal() {
                this.$buefy.modal.open({
                    parent: this,
                    width: 960,
                    component: require('../../modals/shareTimeline').default,
                    props: {
                        timeline: this.timeline,
                    },
                    hasModalCard: true
                });
            }, 

            publishModal() {           
                this.$buefy.modal.open({
                    parent: this,
                    component: require('../../modals/publishTimeline').default,
                    props: {
                        timeline: this.timeline,
                        policies: this.policies.timeline,
                    },
                    hasModalCard: true
                });
            },

            exportModal() {
                this.$buefy.modal.open({
                    parent: this,
                    component: require('../../modals/exportTimeline').default,
                    props: {
                        timeline: this.timeline,
                    },
                    hasModalCard: true
                });
            }, 

            createEventModal() {              
                this.$buefy.modal.open({
                    parent: this,
                    component: require('../../modals/createEvent').default,
                    props: {
                        timeline: this.timeline,
                    },
                    hasModalCard: true
                });
            },

            fetchTimeline(id) {
                return axios.get('/api/v1/timelines/'+id)
                     .then(response => {
                        this.timeline = response.data.timeline;
                        this.policies.timeline = response.data.policies;
                }).catch(response => {
                    this.$buefy.toast.open({
                        message: 'Une erreur s\'est produite',
                        type: 'is-danger'
                    });
                });
            },

            fetchEvents(id) {
                return axios.get('/api/v1/timelines/'+id+'/events')
                     .then(response => {
                        this.events = response.data.events;
                        this.policies.events = response.data.policies;
                }).catch(error => {
                    if (error.response.status != 402) {
                        this.$buefy.toast.open({
                            message: 'Une erreur s\'est produite',
                            type: 'is-danger'
                        });
                    }
                });
            },

            fetchData(id) {
                this.loading = true;
                
                Promise.all([this.fetchTimeline(id), this.fetchEvents(id)])
                .finally( (values) => {
                    this.loading = false;
                });
            }
        },

        created() {
            this.fetchData(this.$route.params.id);
            Bus.$on('timeline.fetch', () => this.fetchData(this.$route.params.id));
        },

        destroyed() {
            Bus.$off('timeline.fetch');
        },

        breadcrumb() {
            return {
                label: this.timeline.title,
                parentsList: [
                    {
                        to: '/',
                        label: 'Commemoria'
                    }
                ]
            }
        },
    }
</script>
<style scoped>
    .draggable-container--is-dragging {
        border: 2px solid #d4d4d8;
        background-image: repeating-linear-gradient(-45deg,white,white 40%,#d4d4d8 0,#d4d4d8 50%,white 0);
        background-size: .5rem .5rem;
        margin: -2px !important;
    }

    .buttons .button, .buttons:last-child {
        margin-bottom: 0;
    }

    .buttons {
        gap: 0.2rem;
    }
</style>